import devConfig from './dev';
import uatConfig from './uat';
import prodConfig from './prod';

const getConfig = () => {
    console.log('Environment:', process.env.NODE_ENV);
    console.log('Custom Environment:', process.env.REACT_APP_ENV);

    switch (process.env.REACT_APP_ENV) {
        case 'uat':
            return uatConfig;
        case 'prod':
        case 'production':
            return prodConfig;
        default:
            return devConfig;
    }
};

const Config = getConfig();
export default Config;
